import { UIConfig2 } from "./UIConfig";
import { Sprite } from "../display/Sprite";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { LayoutChangedReason, RelationType } from "./Const";
import { Controller } from "./Controller";
import { Relation } from "./Relation";
import { GearDisplay } from "./gear/GearDisplay";
import { NodeFlags } from "../Const";
import { UIEvent } from "./UIEvent";
import { Event } from "../events/Event";
import { DragSupport } from "../utils/DragSupport";
import { GrayscaleEffect2D } from "../display/effect2d/ColorEffect2D";
import { LayaEnv } from "../../LayaEnv";
export class GWidget extends Sprite {
    constructor() {
        super();
        this._grayed = false;
        this._draggable = false;
        this._rawWidth = 0;
        this._rawHeight = 0;
        this._deltaWidth = 0;
        this._deltaHeight = 0;
        this._giveWidth = 0;
        this._giveHeight = 0;
        this.sourceWidth = 0;
        this.sourceHeight = 0;
        this._nodeType = 2;
        this._controllers = {};
        this._gears = [];
        this._relations = [];
        this._controllerCount = 0;
        this._initialize();
    }
    get left() {
        return this._x - this._width * this._anchorX;
    }
    set left(value) {
        this.pos(value + this._width * this._anchorX, this.y);
    }
    get top() {
        return this._y - this._height * this._anchorY;
    }
    set top(value) {
        this.pos(this._x, value + this._height * this._anchorY);
    }
    setLeftTop(xv, yv) {
        xv = xv != null ? xv + this._width * this._anchorX : this._x;
        yv = yv != null ? yv + this._height * this._anchorY : this._y;
        this.pos(xv, yv);
    }
    center(target) {
        let r = target;
        if (!r) {
            if (this.parent)
                r = this.parent;
            else
                r = GWidget._defaultRoot;
        }
        this.setLeftTop(Math.floor((r.width - this.width) * 0.5), Math.floor((r.height - this.height) * 0.5));
        return this;
    }
    pos(x, y) {
        var _a, _b, _c;
        if (this._x != x || this._y != y) {
            super.pos(x, y);
            if (((_a = this.parent) === null || _a === void 0 ? void 0 : _a._nodeType) == 2)
                (_c = (_b = this.parent).setLayoutChangedFlag) === null || _c === void 0 ? void 0 : _c.call(_b, LayoutChangedReason.Pos);
            this.event(Event.MOVED);
        }
        return this;
    }
    size(wv, hv, changeByLayout) {
        var _a;
        if (this._width == wv && this._height == hv) {
            if (this._forceSizeFlag)
                this._forceSizeFlag = false;
            else
                return this;
        }
        this._rawWidth = wv;
        this._rawHeight = hv;
        if (!changeByLayout) {
            this._giveWidth = wv;
            this._giveHeight = hv;
        }
        if (wv < 0)
            wv = 0;
        if (hv < 0)
            hv = 0;
        this._deltaWidth = wv - this._width;
        this._deltaHeight = hv - this._height;
        super.size(wv, hv);
        this.setLayoutChangedFlag();
        this._sizeChanged(changeByLayout);
        if (this.parent) {
            if (this._relations.length > 0) {
                for (let item of this._relations)
                    item.applyOnSelfResized();
            }
            if (((_a = this.parent) === null || _a === void 0 ? void 0 : _a._nodeType) == 2)
                this.parent.setLayoutChangedFlag(LayoutChangedReason.Size);
        }
        this.event(Event.RESIZE);
        this._deltaWidth = 0;
        this._deltaHeight = 0;
        return this;
    }
    makeFullSize(target, constraints) {
        let r = target;
        if (!r) {
            if (this.parent instanceof GWidget)
                r = this.parent;
            else
                r = GWidget._defaultRoot;
        }
        this.size(r.width, r.height);
        if (constraints)
            this.addRelation(r, RelationType.Size);
        return this;
    }
    get grayed() {
        return this._grayed;
    }
    set grayed(value) {
        value = !!value;
        if (this._grayed !== value) {
            this._grayed = value;
            let c = this.getController("grayed");
            if (c) {
                c.selectedIndex = value ? 1 : 0;
                value = false;
            }
            let postProcess = this.getPostProcess(value);
            if (value) {
                let effect = postProcess.getEffect(GrayscaleEffect2D);
                if (!effect)
                    effect = postProcess.addEffect(new GrayscaleEffect2D());
            }
            else {
                if (postProcess) {
                    let effect = postProcess.getEffect(GrayscaleEffect2D);
                    if (effect) {
                        postProcess.removeEffect(effect);
                        if (!LayaEnv.isPlaying && postProcess.effects.length === 0)
                            this.postProcess = null;
                    }
                }
            }
        }
    }
    get enabled() {
        return !this.grayed && this.mouseEnabled;
    }
    set enabled(value) {
        this.grayed = !value;
        this.mouseEnabled = value;
    }
    get internalVisible() {
        return !this._getBit(NodeFlags.NOT_IN_PAGE);
    }
    set internalVisible(value) {
        var _a;
        if (((this._bits & NodeFlags.NOT_IN_PAGE) === 0) !== value) {
            this._setBit(NodeFlags.NOT_IN_PAGE, !value);
            this._processVisible();
            if (((_a = this._parent) === null || _a === void 0 ? void 0 : _a.activeInHierarchy) && this.active)
                this._processActive(value, true);
        }
    }
    get tooltips() {
        return this._tooltips;
    }
    set tooltips(value) {
        if (this._tooltips) {
            this.off(Event.ROLL_OVER, this, this._rollOver);
            this.off(Event.ROLL_OUT, this, this._rollOut);
        }
        this._tooltips = value;
        if (this._tooltips) {
            this.on(Event.ROLL_OVER, this, this._rollOver);
            this.on(Event.ROLL_OUT, this, this._rollOut);
        }
    }
    _rollOver() {
        GWidget._defaultRoot.popupMgr.showTooltips(this._tooltips, UIConfig2.defaultTooltipsShowDelay);
    }
    _rollOut() {
        GWidget._defaultRoot.popupMgr.hideTooltips();
    }
    get text() {
        return "";
    }
    set text(value) {
    }
    get icon() {
        return null;
    }
    set icon(value) {
    }
    get background() {
        return this._background;
    }
    set background(value) {
        if (this._background)
            this.graphics.removeCmd(this._background, true);
        this._background = value;
        if (value) {
            value.lock = true;
            this.graphics.addCmd(value, 0);
        }
    }
    get draggable() {
        return this._draggable;
    }
    set draggable(value) {
        if (this._draggable != value) {
            this._draggable = value;
            if (value) {
                if (!this._dragSupport)
                    this._dragSupport = new DragSupport(this);
            }
            if (this._dragSupport)
                this._dragSupport.autoStart = value;
        }
    }
    get relations() {
        return this._relations;
    }
    set relations(value) {
        if (this._relations.length > 0)
            this._relations.filter(g => !value.includes(g)).forEach(g => g.owner = null);
        this._relations = value;
        value.forEach(g => g.owner = this);
    }
    _addRelations(value) {
        for (let v of value) {
            v.owner = this;
            this._relations.push(v);
        }
    }
    addRelation(target, type, percent) {
        let item = this._relations.find(i => i.target == target);
        if (!item) {
            item = new Relation();
            item.owner = this;
            item.target = target;
            this._relations.push(item);
        }
        item.add(type, percent);
        return this;
    }
    removeRelation(target, type) {
        let item = this._relations.find(i => i.target == target);
        if (item)
            item.remove(type);
        return this;
    }
    clearRelations() {
        this._relations.length = 0;
        return this;
    }
    get controllers() {
        return this._controllers;
    }
    get controllerCount() {
        return this._controllerCount;
    }
    set controllers(value) {
        this._controllers = value;
        let i = 0;
        for (let k in value) {
            value[k].name = k;
            value[k].owner = this;
            i++;
        }
        this._controllerCount = i;
        this._controllersChanged();
    }
    addController(name, pageCount) {
        if (this._controllers[name]) {
            console.warn(`controller ${name} already exists`);
            return this._controllers[name];
        }
        let c = new Controller();
        c.name = name;
        c.owner = this;
        if (pageCount != null)
            c.numPages = pageCount;
        this._controllers[name] = c;
        this._controllerCount++;
        this._controllersChanged();
        return c;
    }
    getController(name) {
        return this._controllers[name];
    }
    setPage(controllerName, page) {
        let c = this._controllers[controllerName];
        if (!c)
            return;
        if (typeof (page) === "number")
            c.selectedIndex = page;
        else
            c.selectedPage = page;
    }
    _controllersChanged() {
        this.event(UIEvent.ControllersChanged);
    }
    get gears() {
        return this._gears;
    }
    set gears(value) {
        let visChanged;
        if (this._gears.length > 0) {
            this._gears.filter(g => !value.includes(g)).forEach(g => {
                if (g instanceof GearDisplay)
                    visChanged = true;
                g.owner = null;
            });
        }
        this._gears = value;
        value.forEach(g => g.owner = this);
        if (visChanged)
            GearDisplay.check(this);
    }
    _addGears(value) {
        this._gears.push(...value);
        value.forEach(g => g.owner = this);
    }
    addGear(value) {
        this._gears.push(value);
        value.owner = this;
    }
    removeGear(value) {
        let i = this._gears.indexOf(value);
        if (i != -1) {
            this._gears.splice(i, 1);
            value.owner = null;
        }
    }
    onClick(caller, listener, args) {
        if (arguments.length == 1) {
            listener = caller;
            caller = null;
        }
        this.on(Event.CLICK, caller, listener, args);
    }
    offClick(caller, listener) {
        if (arguments.length == 1) {
            listener = caller;
            caller = null;
        }
        this.off(Event.CLICK, caller, listener);
    }
    destroy() {
        if (this._background)
            this._background.lock = false;
        super.destroy();
        for (let k in this._controllers)
            this._controllers[k].offAll();
        for (let g of this._gears)
            g.owner = null;
    }
    _sizeChanged(changeByLayout) {
    }
    _childChanged(child) {
        super._childChanged(child);
        this.setLayoutChangedFlag(LayoutChangedReason.Hierarchy);
    }
    _processVisible() {
        var _a, _b, _c;
        if (super._processVisible()) {
            if (((_a = this.parent) === null || _a === void 0 ? void 0 : _a._nodeType) == 2)
                (_c = (_b = this.parent).setLayoutChangedFlag) === null || _c === void 0 ? void 0 : _c.call(_b, LayoutChangedReason.Visible);
            return true;
        }
        else
            return false;
    }
    setLayoutChangedFlag(reason) {
    }
    _onConstruct(inPrefab) {
        if (inPrefab && this._relations.length > 0) {
            for (let r of this._relations) {
                r._sw = this._width;
                r._sh = this._height;
                if (r.target)
                    r.target._forceSizeFlag = true;
            }
        }
        this.onConstruct();
    }
    onConstruct() {
    }
    onAfterDeserialize() {
        super.onAfterDeserialize();
        if (SerializeUtil.hasProp("_startPages")) {
            let col = this._startPages;
            if (col) {
                for (let k in col) {
                    let c = this.getController(k);
                    if (c)
                        c.selectedIndex = col[k];
                }
            }
        }
    }
}
